import { baseRestApi } from "api/rest/baseRestApi";
import { ApiResponsePaginatedCursor } from "api/rest/types/responses";
import { Mode } from "types/Mode";
import { QuoteStatus } from "types/QuoteStatus";
import enhanceWithPagination from "utils/enhanceWithPagination";

import { PaginatedApiRequestQueryArgs } from "../types/requests";
import { ShipperQuoteRequest } from "./types";

type QueryArgs = PaginatedApiRequestQueryArgs<{
  queryParams: {
    search?: string;
    mode?: Mode[];
    status?: QuoteStatus[];
  };
}>;

type ResponseType = ApiResponsePaginatedCursor<{ quoteRequests: Array<ShipperQuoteRequest> }>;

module.hot?.accept();

export const getManyShipperQuoteRequestsApi = baseRestApi
  .enhanceEndpoints({ addTagTypes: ["QUOTE_REQUESTS"] })
  .injectEndpoints({
    overrideExisting: module.hot?.status() === "apply",
    endpoints: (builder) => ({
      getManyShipperQuoteRequests: builder.query<ResponseType, QueryArgs>({
        query: ({ queryParams }) => ({
          method: "GET",
          url: `shipper/quote-requests/`,
          params: queryParams,
        }),
        providesTags: ["QUOTE_REQUESTS"],
      }),
    }),
  });

export const { useGetManyShipperQuoteRequestsQuery } = getManyShipperQuoteRequestsApi;
export const { useGetManyShipperQuoteRequestsQuery: usePaginatedGetManyShipperQuoteRequestsQuery } =
  enhanceWithPagination(getManyShipperQuoteRequestsApi, "getManyShipperQuoteRequests");
